import { Injectable } from '@angular/core';
import {
    CanActivate, Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot
} from '@angular/router';
import { MenuService } from '../menu/menu.service';

@Injectable()
export class AuthorizationGuard implements CanActivate {
    constructor(
        private menuService: MenuService,
        private router: Router
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const url = state.url;
        
        if (this.menuService.isUrlEnabled(url)) {
            return true;
        }

        // Redirect to home if not authorized
        this.router.navigate(['/home']);
        return false;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/auth/authorization-guard.service.ts